import React from 'react';

export default function ShareLinkIcon(props: {
  className?: string;
  fill?: string;
}) {
  return (
    <svg
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.222 19.778C5.197 20.753 6.477 21.24 7.757 21.24C9.038 21.239 10.319 20.753 11.293 19.778L14.121 16.949L12.707 15.535L9.879 18.364C8.71 19.531 6.807 19.533 5.636 18.364C4.467 17.194 4.467 15.291 5.636 14.121L8.465 11.293L7.051 9.879L4.222 12.707C2.273 14.656 2.273 17.829 4.222 19.778ZM19.778 11.293C21.726 9.344 21.726 6.171 19.778 4.222C17.828 2.272 14.655 2.274 12.707 4.222L9.879 7.051L11.293 8.465L14.121 5.636C15.291 4.469 17.194 4.467 18.364 5.636C19.533 6.806 19.533 8.709 18.364 9.879L15.535 12.707L16.949 14.121L19.778 11.293Z"
        fill={props.fill || '#474B50'}
      />
      <path
        d="M8.46362 16.9504L7.04943 15.5362L15.5356 7.05036L16.9498 8.4646L8.46362 16.9504Z"
        fill={props.fill || '#474B50'}
      />
    </svg>
  );
}
